import connectToStores from 'alt-utils/lib/connectToStores'
import { PlusActions } from 'actions'
import { PlusStore } from 'stores'
import { ManageInstall } from 'components'

@connectToStores
export default class ManagePlusContainer extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired
  }

  static getStores() {
    return [
      PlusStore
    ]
  }

  static getPropsFromStores() {
    return {
      ...PlusStore.getState()
    }
  }

  componentWillMount() {
    PlusActions.fetch()

    const queryString = require("query-string")
    const { autoInstall } = queryString.parse(this.props.location.search)

    // clear the autoInstall from browser history to prevent rerunning when
    // navigating back here
    if (autoInstall) {
      const url = window.location.href.replace(/\?.*$/, "")
      window.history.replaceState({}, document.title, url)
    }

    this.setState({ autoInstall: !!autoInstall })
  }

  render() {
    return (
      <ManageInstall
        isInstalling = {this.props.isInstalling}
        installed    = {this.props.installed}
        isUpgrade    = {this.props.isUpgrade}
        status       = {this.props.status}
        failed       = {this.props.failed}
        installNow   = {this.state.autoInstall}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/plus/ManageInstallContainer.js